import { JSEncrypt } from 'jsencrypt';

export const encryptedData = data => {
    const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQChAEgKDWXk03NX1IrBvD7fye8yHOADydpwUF4BDT14kMXltIfrf4XQfJhnHsWG3ZMKWR/cIYlFrXxATVLdLiLVFq3+buJPZE9o3KhS4P+sQyjQ5pPLMnbvT9zRYvz2Vftwt4Iu6IVpcdacdxyyq/XgYKqQuhmxIVdB/bx9egGxNQIDAQAB';
    const encryptor = new JSEncrypt();
    encryptor.setPublicKey(publicKey);
    return encryptor.encrypt(data);
};

export const encodeData = (hmacKey, data) => {
    let encoded = JSON.stringify(data);
    // const hmac = crypto.createHmac('sha256', hmacKey);
    // hmac.update(encoded);
    // data.signature = hmac.digest()
    //     .toString('hex');
    encoded = JSON.stringify(data);
    return encoded;
};